
        import {css} from 'lit';
        export default css`@property --shadow-top{syntax:"<percentage>";initial-value:55%;inherits:false}@property --shadow-middle{syntax:"<percentage>";initial-value:75%;inherits:false}@property --shadow-bottom{syntax:"<percentage>";initial-value:90%;inherits:false}button{text-align:left}`;
    